import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { SharedService } from './services/shared.service';
import { Store } from '@ngxs/store';
import { Utility } from './core/common';
import { AuthState, Current } from './states/auth.state';
import { AppService } from './services/app.service';
import { environment } from '../environments/environment';
import { ValuesService } from './services/values.service';
import { ActionLogService } from './services/actionlog.service';
import { PushService } from './services/push.service';
import { Subject, firstValueFrom } from 'rxjs';
import { ChatService } from './services/chat.service';
import { SetUtm, UtmState } from './states/utm.state';
import { ResumeOnboardingModalComponent } from './modules/seeker/components/resume-onboarding-modal/resume-onboarding-modal.component';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @ViewChild(ResumeOnboardingModalComponent) resumeOnboardingModal: ResumeOnboardingModalComponent;
  env: string;
  expandDebug = false;
  user: any;
  constructor(private store: Store, private location: Location, public appService: AppService, public valuesService: ValuesService,
    public actionLogService: ActionLogService, public sharedService: SharedService, public pushService: PushService,
    private chatService: ChatService, private router: Router) {
    this.appService.registerCheckForUpdates();
    this.env = environment.app.env;
  }

  Utility = Utility;
  showSupport: boolean;

  async ngOnInit() {    
    if (!this.sharedService.isBrowser) return;

    try {
      this.setUtmParams();
      const sourceDomain = Utility.getQueryParam(location, 'source-domain');
      if (sourceDomain) {
        Utility.sourceDomain = sourceDomain;
      }
    } catch { }

    try { this.store.dispatch(Current).toPromise(); } catch (e) {
      console.log('Current', e);
    }

    this.pushService.onMessage$(AuthState.userChangedMessageType)
      .subscribe(async (_: { token: string }) => await firstValueFrom(this.store.dispatch(new Current(_.token))));

    document.addEventListener("visibilitychange", () => this.onClientChange());
    window.onunload = () => this.onClientChange();

    AuthState.user$.subscribe(() => {
      this.user = Utility.clone(this.store.selectSnapshot(state => state.auth.user));
      this.openResumeOnboardingOnHome();
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd)
        this.openResumeOnboardingOnHome(event.urlAfterRedirects);
    });

    this.chatService.listenCommands();
  }

  private onClientChange() {
    return this.pushService.postBroadcastMessage({ type: 'client-change' });
  }

  private openResumeOnboardingOnHome(url = this.router.url): void {
    const path = url.split('?')[0].split('#')[0];
    if (path !== '/') {
      this.resumeOnboardingModal?.closeIfOpen();
      return;
    }
    setTimeout(() => this.resumeOnboardingModal?.open());
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.onClientChange();
  }


  async setUtmParams() {
    const params = this.sharedService.getQueryParamsObject(this.location.path());
    let utm = null;
    if (params) {
      for (const p in params) {
        if (p.startsWith('utm_')) {
          utm = utm || {};
          utm[p] = params[p];
        }
      }
    }

    if (!utm && this.sharedService.isBrowser && document.referrer) {
      const current = this.store.selectSnapshot(UtmState.utm);
      if (!current) {
        utm = { isReferrer: true, utm_source: this.sharedService.getDomain(document.referrer) };
      }
    }

    if (utm) {
      await this.store.dispatch(new SetUtm(utm)).toPromise();
      this.actionLogService.log({ Category: 'User', Action: 'utm-click' });
    }
  }


}
